
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

const ButtonCommandMscTool = (props) => {

    const classNames = mergeStyleSets({
        default: {
            backgroundColor: 'rgba(128, 128, 128, 0.7)'
        },
        selected: {
            backgroundColor: 'rgba(64, 64, 64, 0.7)'
        }
    });

    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.toolId);
        }
    }

    const getClassName = () => {
        return (props.selected) ? classNames.selected : classNames.default;
    }

    return (
        <IconButton
            className={getClassName()}
            iconProps={{
                imageProps: {
                    src: MultiSceneCore.PointCloudScene.Icons[props.iconName]
                }
            }}
            title={props.title}
            onClick={onClick}
            styles={{
                icon: {
                    height: 24,
                    width: 24
                }
            }}
        />
    );
}

export default ButtonCommandMscTool;
